import {defineMessages} from 'react-intl';

export const sectionsMessages = defineMessages({
  choose: { id: 'sections.choose' },
  chooseOne: { id: 'sections.choose_one' },
});
